import React from 'react'
import Image from './image'
import soldOut from '../../../static/images/sold-out.png'

export default class PastPeople extends React.Component {
  render() {
    return (
      <section className="past-trips">
        <div className="wrap">
          <h2>Trips by Year</h2>
          <ol>
            <li>
              <h3>
                <strong>Love Song Couples Getaway Maui 2019</strong>
                <span>The Ritz-Carlton, Kapalua</span>
              </h3>
              <time>September 21-27, 2019</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Kauai 2019</strong>
                <span>Grand Hyatt Kauai Resort & Spa, Kauai, Hawaii</span>
              </h3>
              <time>May 26 - June 1, 2019</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Maui 2018</strong>
                <span>The Ritz-Carlton, Kapalua</span>
              </h3>
              <time>September 22-28, 2018</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Cancun 2018</strong>
                <span>The Ritz-Carlton, Cancun</span>
              </h3>
              <time>May 13-19, 2018</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Hawaii 2017</strong>
                <span>Grand Hyatt Kauai Resort & Spa, Kauai, Hawaii</span>
              </h3>
              <time>May 28-June 3, 2017</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Bahamas 2017</strong>
                <span>Atlantis | Royal Towers & The Cove, Bahamas</span>
              </h3>
              <time>May 14-20, 2017</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Hawaii 2016</strong>
                <span>Grand Hyatt Kauai Resort & Spa, Kauai, Hawaii</span>
              </h3>
              <time>May 29-June 4, 2016</time>
              <img src={soldOut} alt="Sold Out" />
            </li>
            <li>
              <h3>
                <strong>Love Song Couples Getaway Bahamas 2016</strong>
                <span>Atlantis, Paradise Island, Bahamas</span>
              </h3>
              <time>May 8-14, 2016</time>
              <img src={soldOut} alt="Sold Out" />
            </li>
            <li>
              <h3>
                <strong>Love Song Couples Getaway Hawaii 2015</strong>
                <span>Grand Wailea Resort & Spa, Maui, Hawaii</span>
              </h3>
              <time>May 23-29, 2015</time>
              <img src={soldOut} alt="Sold Out" />
            </li>
            <li>
              <h3>
                <strong>Love Song Couples Getaway Bahamas 2015</strong>
                <span>Atlantis, Paradise Island, Bahamas</span>
              </h3>
              <time>May 10-16, 2015</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Hawaii 2014</strong>
                <span>Grand Wailea Resort & Spa, Maui, Hawaii</span>
              </h3>
              <time>May 24-30, 2014</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Bahamas 2014</strong>
                <span>Atlantis, Paradise Island, Bahamas</span>
              </h3>
              <time>May 11-17, 2014</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Hawaii 2013</strong>
                <span>Grand Wailea Resort & Spa, Maui, Hawaii</span>
              </h3>
              <time>May 25-31, 2013</time>
              <img src={soldOut} alt="Sold Out" />
            </li>

            <li>
              <h3>
                <strong>Love Song Couples Getaway Hawaii 2012</strong>
                <span>Hilton Waikoloa Village, Big Island, Hawaii</span>
              </h3>
              <time>August 18-24 2012</time>
              <img src={soldOut} alt="Sold Out" />
            </li>
            <li>
              <h3>
                <strong>Love Song Couples Getaway Hawaii 2011</strong>
                <span>Grand Wailea Resort & Spa, Maui, Hawaii</span>
              </h3>
              <time>May 21-27, 2011</time>
              <img src={soldOut} alt="Sold Out" />
            </li>
          </ol>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/past-trips.js